export default {
  path: "/rules",
  name: "Statutory Rules",
  htmlContent: "rules.html",
  headings: [],
};
